import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import {switchMap, tap, finalize} from 'rxjs/operators';
import { AuthService } from './AuthService';
import { environment } from '../../environments/environment';
import {LoadingService} from '../Services/loading.service';


@Injectable({providedIn:'root'})
/*export class AuthInterceptorService implements HttpInterceptor {
    constructor(private authService: AuthService,
                private _router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.startsWith(environment.apiRoot)) {
            return from(this.authService.getAccessToken()).pipe( // Convert Promise to Observable
                switchMap((token: any) => {
                    let headers = new HttpHeaders()
                        .set('Accept', 'application/json')
                        .set('Authorization', `Bearer ${token}`);

                    // Only set 'Content-Type' if it's not a FormData request
                    if (!(req.body instanceof FormData)) {
                        headers = headers.set('Content-Type', 'application/json');
                    }

                    const authReq = req.clone({ headers });
                    return next.handle(authReq).pipe(
                        tap(
                            () => {},
                            (error) => {
                                const respError = error as HttpErrorResponse;
                                if (respError && (respError.status === 401 || respError.status === 403)) {
                                    this._router.navigate(['/unauthorized']);
                                }
                            }
                        )
                    );
                })
            );
        } else {
            return next.handle(req);
        }
    }

    /!*intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.startsWith(environment.apiRoot)) {
            return from(this.authService.getAccessToken().then((token: any) => {
                let headers = new HttpHeaders()
                    .set('Accept', 'application/json')
                    .set('Authorization', `Bearer ${token}`);

                // Only set 'Content-Type' if it's not a FormData request
                if (!(req.body instanceof FormData)) {
                    headers = headers.set('Content-Type', 'application/json');
                }

                const authReq = req.clone({ headers });
                return next.handle(authReq).pipe(tap(_ => { }, error => {
                    const respError = error as HttpErrorResponse;
                    if (respError && (respError.status === 401 || respError.status === 403)) {
                        this._router.navigate(['/unauthorized']);
                    }
                })).toPromise();
            }));
        } else {
            return next.handle(req);
        }
    }*!/
}*/
export class AuthInterceptorService implements HttpInterceptor {

    constructor(
        private authService: AuthService,
        private _router: Router,
        private loadingService: LoadingService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Show loading spinner for all requests
        this.loadingService.showLoading();

        if (req.url.startsWith(environment.apiRoot)) {
            return from(this.authService.getAccessToken()).pipe(
                switchMap((token: string | null) => {
                    if (!token) {
                        return next.handle(req);
                    }
                    let headers = new HttpHeaders()
                        .set('Accept', 'application/json')
                        .set('Authorization', `Bearer ${token}`);

                    // Only set 'Content-Type' if it's not a FormData request
                    if (!(req.body instanceof FormData)) {
                        headers = headers.set('Content-Type', 'application/json');
                    }

                    const authReq = req.clone({ headers });
                    return next.handle(authReq).pipe(
                        tap(
                            () => {},
                            (error) => {
                                const respError = error as HttpErrorResponse;
                                if (respError && (respError.status === 401 || respError.status === 403)) {
                                    this._router.navigate(['/unauthorized']);
                                }
                            }
                        ),
                        finalize(() => {
                            // Hide loading spinner when request completes (success or error)
                            this.loadingService.hideLoading();
                        })
                    );
                })
            );
        } else {
            return next.handle(req).pipe(
                finalize(() => {
                    // Hide loading spinner for non-API requests too
                    this.loadingService.hideLoading();
                })
            );
        }
    }
}